import './event-block.scss';
import $ from 'jquery';

export default () => {
	// When clicking on button with id showAllEvents, get all elements with class hiddeItem and set styling display to block
	$( '#showAllEvents' ).on( 'click', ( event ) => {
		event.preventDefault();
		$( '.hiddeItem' ).css( 'display', 'block' );
	} );
};
